// Small presentational atoms for the Visitor module — RON-5466.
//
// Kept together because they are one-liners that always travel as a set. All styling is BEM in
// `styles/components/visitor.css`; colour comes from a modifier class, never an inline style.

import { useTranslation } from "react-i18next";

import {
  VISIT_KIND,
  VISIT_TYPE,
  getInitials,
  getKindLabelKey,
  getStatusLabelKey,
} from "../visitorConstants.js";

// Initials chip. VIP visitors get the amber treatment, matching the prototype.
export const VisitorAvatar = ({ name, type }) => (
  <span
    className={`visitor-avatar${
      type === VISIT_TYPE.VIP ? " visitor-avatar--vip" : ""
    }`}
    aria-hidden="true"
  >
    {getInitials(name)}
  </span>
);

export const VisitorStatusBadge = ({ status }) => {
  const { t } = useTranslation("common");

  return (
    <span className={`visitor-badge visitor-badge--status-${status}`}>
      {t(getStatusLabelKey(status))}
    </span>
  );
};

export const VisitorKindBadge = ({ kind }) => {
  const { t } = useTranslation("common");

  return (
    <span
      className={`visitor-badge visitor-badge--kind-${
        kind === VISIT_KIND.CONTRACTOR ? "contractor" : "visitor"
      }`}
    >
      {t(getKindLabelKey(kind))}
    </span>
  );
};

export const VisitorVipBadge = () => {
  const { t } = useTranslation("common");

  return (
    <span className="visitor-badge visitor-badge--vip">
      {t("react_visitors_vip")}
    </span>
  );
};

// Contractors booked before their vetting cleared. They cannot be admitted on site until it is
// approved, so the list flags them next to the name.
export const VisitorProvisionalBadge = () => {
  const { t } = useTranslation("common");

  return (
    <span className="visitor-badge visitor-badge--provisional">
      {t("react_visitors_provisional")}
    </span>
  );
};
